import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AUTH_SERVICE } from './auth-base.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AUTH_SERVICE);
  if (!auth.token) return next(req);
  return next(
    req.clone({
      headers: req.headers.set('Authorization', `Bearer ${auth.token}`),
    })
  );
};
